<div class="dialog-content">
  <h2>Consulter / Modifier une entité</h2>
  <mat-divider></mat-divider>
  <form [formGroup]="entiteForm">
    <div class="libelle-action-section">
      <div class="libelle-section">
        <label>Entité<span class="required-star">*</span> :</label>
        <mat-form-field appearance="outline">
          <mat-label>Libellé de l'entité</mat-label>
          <input formControlName="libelle" matInput>
          @if (entiteForm.get('libelle')?.errors?.['libelleExists']) {
            <mat-error>
              Une entité existe déjà avec ce libellé.
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="actif-section">
        <mat-button-toggle-group aria-label="Type" formControlName="actif">
          <mat-button-toggle [class.entite-active]="entiteForm.controls.actif.value == 'active'"
                             value="active">
            Activée
          </mat-button-toggle>
          <mat-button-toggle [class.entite-inactive]="entiteForm.controls.actif.value == 'desactive'"
                             value="desactive">
            Désactivée
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>

    <div class="type-section">
      <label>Type<span class="required-star">*</span> :</label>
      <mat-button-toggle-group aria-label="Type" formControlName="interne">
        <mat-button-toggle value="interne">Interne</mat-button-toggle>
        <mat-button-toggle value="externe">Externe</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <div class="referent-section">
      <label>Référent :</label>
      <div class="fields">
        <mat-form-field appearance="outline">
          <mat-label>Nom du Référent</mat-label>
          <input formControlName="referentNom" matInput>
          <mat-icon matPrefix>person</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Email du Référent</mat-label>
          <input formControlName="referentEmail" matInput type="email">
          <mat-icon matPrefix>mail</mat-icon>
          @if (entiteForm.get('referentEmail')?.touched && entiteForm.get('referentEmail')?.hasError('email')) {
            <mat-error>
              Veuillez saisir une adresse e-mail valide.
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Téléphone du Référent</mat-label>
          <input formControlName="referentTelephone" matInput type="tel">
          <mat-icon matPrefix>smartphone</mat-icon>
          @if (entiteForm.get('referentTelephone')?.touched && entiteForm.get('referentTelephone')?.hasError('pattern')) {
            <mat-error>
              Veuillez saisir un numéro de téléphone valide.
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <mat-divider></mat-divider>
    <div class="message-required">
      <p>Les champs suivis d'un <span class="required-star">*</span> sont obligatoires.</p>
    </div>

    <div class="actions">
      <div class="align">
        <button (click)="onClose()" mat-raised-button>
          ANNULER
        </button>
        <button (click)="onSubmit()" [disabled]="isEntiteInitiallyDesactive && entiteForm.get('actif')?.value !== 'active'" [ngClass]="{'button-disabled': isEntiteInitiallyDesactive && entiteForm.get('actif')?.value !== 'active'}"
                class="button-validate"
                mat-raised-button>
          VALIDER
        </button>
      </div>
    </div>
  </form>
</div>
